<template>
  <el-dialog
    :title="model.stock_type == 1 ? '成品入库' : '成品出库'"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="80px"
      size="small"
    >
      <el-form-item label="名称">
        <div>{{ model.name }}</div>
      </el-form-item>
      <el-form-item label="编码" prop="stock_product_id">
        <ProductSelect
          v-model="model.stock_product_id"
          :templateid="model.product_template_id"
          :stockType="-1"
          :codeType="2"
          :status="1"
        ></ProductSelect>
      </el-form-item>
      <el-form-item
        label="出库基地"
        prop="from_base_id"
        v-if="model.stock_type == 2"
      >
        <BaseSelect
          v-model="model.from_base_id"
          :filterBlank="true"
          :authLimit="true"
        ></BaseSelect>
      </el-form-item>
      <el-form-item
        v-if="!model.towell && visible"
        :label="model.stock_type == 2 ? '接收基地' : '入库基地'"
        prop="to_base_id"
      >
        <BaseSelect
          v-model="model.to_base_id"
          :filterBlank="true"
          :stockOutProductId="model.id"
        ></BaseSelect>
      </el-form-item>
      <el-form-item
        label="接收钻井"
        prop="to_well_id"
        v-if="model.stock_type == 2 && model.towell"
      >
        <DrillWellSelect v-model="model.to_well_id"></DrillWellSelect>
      </el-form-item>
      <el-form-item label="数量" prop="number">
        <el-input-number
          style="width: 177px"
          v-model="model.number"
          :min="1"
          :max="100000"
          :step-strictly="true"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="model.remark"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        :disabled="submiting"
        @click="submitForm"
        >确 认</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { productNew, productUpdate } from '@/service/getData'
import ProductSelect from '../../components/select/product_select.vue'
export default {
  components: {
    ProductSelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      submiting: false,
      visible: this.show,
      rules: {
        code: [{ required: true, message: '请填写', trigger: 'blur' }],
        stock_product_id: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        from_base_id: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        to_base_id: [{ required: true, message: '请选择', trigger: 'change' }],
        to_well_id: [{ required: true, message: '请选择', trigger: 'change' }],
      },
    }
  },
  methods: {
    submitForm() {
      if (this.submiting) return
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          this.submiting = true
          if (this.model.id > 0) {
            let res = await productUpdate(data)
            if (res.status == 0) {
              this.$emit('callback', res.data)
              this.visible = false
            }
          } else {
            let res = await productNew(data)
            if (res.status == 0) {
              this.$emit('callback', res.data)
              this.visible = false
            }
          }
          this.submiting = false
        } else {
          console.log('error submit!!')
          this.submiting = false
          return false
        }
      })
    },
  },
}
</script>